'use client'

import { getUpdatedOrder } from '@/app/actions/cartActions'
import { useCart } from '@/hooks/useCart'
import type { IFormattedOrder } from '@a24/av-sdk/order-sdk'
import type { IFormattedLegend } from '@a24/av-sdk/seat-map-sdk'

import { useEffect, useRef, useTransition } from 'react'

export const useOrderSync = (cartLegends: IFormattedLegend[]) => {
  const { orderItemCount, isHydrated } = useCart()
  const [isPending, startTransition] = useTransition()
  const previousItemCount = useRef<number | undefined>(undefined)
  const formattedOrderRef = useRef<IFormattedOrder | null>(null)

  useEffect(() => {
    console.debug(
      'useOrderSync :: Initializing order sync',
      isHydrated,
      orderItemCount
    )
  }, [isHydrated, orderItemCount])

  useEffect(() => {
    // Only run after hydration
    if (!isHydrated) return

    // Only call server action if the count actually changed
    if (orderItemCount !== previousItemCount.current) {
      previousItemCount.current = orderItemCount

      // Skip the initial undefined -> number transition
      if (orderItemCount !== undefined) {
        startTransition(async () => {
          try {
            const order = await getUpdatedOrder(cartLegends)
            formattedOrderRef.current = order
          } catch (error) {
            console.error('Failed to sync order:', error)
          }
        })
      }
    }
  }, [orderItemCount, cartLegends, isHydrated])

  return { isSyncing: isPending, formattedOrder: formattedOrderRef.current }
}
